<app-leveltwo [pageId]="2">
  <div class="General">

      <h3>{{'WelfareExemption.SearchTitle'|translate}}</h3>

      <p>{{'WelfareExemption.Under'|translate}} <a href="#">{{'WelfareExemption.section4b'|translate}}</a> {{'WelfareExemption.and'|translate}} <a href="#">{{'WelfareExemption.section214'|translate}}</a> {{'WelfareExemption.ofthe'|translate}} <a href="#">{{'WelfareExemption.Californiarev'|translate}}</a> {{'WelfareExemption.TheLegislature'|translate}}</p>

      <p>{{'WelfareExemption.Undernew'|translate}}</p>
      <ul>
        <li>{{'WelfareExemption.AnIRS'|translate}}</li>
        <li>{{'WelfareExemption.Articlesof'|translate}}</li>
        <li>{{'WelfareExemption.Copiesof'|translate}}</li>
      </ul>

      <p>{{'WelfareExemption.IftheBOE'|translate}}</p>
      <p>{{'WelfareExemption.TheBOE'|translate}}</p>



  </div>
</app-leveltwo>
